// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__6uZmZ","content":"styles_content__R8kk5","menu":"styles_menu__q5NqW","divider":"styles_divider__XigSt","containerFooter":"styles_containerFooter__M5AoB"};